import React from "react";

import RscHbCardEvent from "~components/molecules/rsc_hb_card/rsc_hb_card_event/rsc_hb_card_event";

import { RESOURCE_HUB_SECTION } from "../../../../prop_types";
import { GRID_SPLIT_ARTICLES } from "../../grid_splits";
import RscHbSectionInner from "../rsc_hb_section_inner/rsc_hb_section_inner";

export default function RscHbSectionEvents({ content }) {
  if (
    content?.title &&
    content?.link &&
    content?.linkTitle &&
    content?.items?.length > 0
  ) {
    return (
      <RscHbSectionInner
        title={content.title}
        link={content.link}
        linkTitle={content.linkTitle}
        gridSplit={GRID_SPLIT_ARTICLES}
      >
        {content.items.map((item) => {
          return <RscHbCardEvent {...item} key={item.title} block />;
        })}
      </RscHbSectionInner>
    );
  }
  return null;
}

RscHbSectionEvents.propTypes = {
  content: RESOURCE_HUB_SECTION.isRequired,
};
